function handleProductSubmission(button, isConfigurable) {
    const currency = button.dataset.currency;
    const language = button.dataset.language;
    const spinner = button.querySelector('.loading__spinner');
    const baseUrl = document.querySelector("html")?.getAttribute("data-base-url");
    const countryId = document.querySelector("html")?.getAttribute("data-country-id");

    button.addEventListener('click', async (event) => {
        event.preventDefault();

        const selectedVariantScript = document.querySelector('script[data-selected-variant]');
        if (!selectedVariantScript) {
            return;
        }

        let selectedVariant;
        try {
            selectedVariant = JSON.parse(selectedVariantScript.textContent.trim());
        } catch (error) {
            console.error("Errore nel parsing del JSON:", error);
            return;
        }

        const variantId = selectedVariant.id;
        const sku = selectedVariant.sku;

        const apiUrl = isConfigurable 
            ? `${baseUrl}/a/ext/api/v1/consumer/products/fromShopify/sku/${sku}`
            : `${baseUrl}/a/ext/api/v1/consumer/products/fromShopify/sku/${sku}/variantId/${variantId}`;

        spinner.classList.remove('hidden');

        const myHeaders = new Headers();
        myHeaders.append("x-user-country-id", countryId);
        myHeaders.append("x-user-currency", currency);
        myHeaders.append("x-user-customer-id", "3");
        myHeaders.append("x-user-language", language);
        myHeaders.append("Content-Type", "application/json");
        myHeaders.append("x-user-session", localStorage.getItem('shopify_session'));

        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            redirect: "follow"
        };

        try {
            const response = await fetch(apiUrl, requestOptions);
            
            if (response.ok) {
                const responseData = await response.json();
                
                if (responseData.id) {
                    const groupId = `group-${Date.now()}`;
                    await addToCart(variantId, responseData.id, {
                        _data_group: groupId
                    });
                }
            } else {
                const errorResponse = await response.json();
                console.error("Errore nell'aggiunta del prodotto:", errorResponse);
            }
        } catch (error) {
            console.error("Errore di rete:", error);
        } finally {
            spinner.classList.add('hidden');
        }
    });
}

const submitConfigurableElement = document.querySelector('.product-form__submit-configurable');
if (submitConfigurableElement) {
    handleProductSubmission(submitConfigurableElement, true);
}

const submitUnConfigurableElement = document.querySelector('.product-form__submit-unconfigurable');
if (submitUnConfigurableElement) {
    handleProductSubmission(submitUnConfigurableElement, false);
}

function setupButtonTrigger(stickySelector, formSelector) {
    const stickyButton = document.querySelector(stickySelector);
    const formButton = document.querySelector(formSelector);

    if (stickyButton && formButton) {
        stickyButton.addEventListener('click', function (event) {
            event.preventDefault();
            formButton.click();
        });
    }
}

setupButtonTrigger('.product-sticky__submit', '.product-form__submit');

document.addEventListener('DOMContentLoaded', () => {
    const observerTarget = document.querySelector('.product-form__buttons');
    const stickyCart = document.querySelector('.product__sticky-cart');
    let lastScrollY = window.scrollY;
  
    if (!observerTarget || !stickyCart) return;
  
    const observerCallback = (entries) => {
      entries.forEach((entry) => {
        const currentScrollY = window.scrollY;
        const isScrollingDown = currentScrollY > lastScrollY;
        lastScrollY = currentScrollY;
  
        const shouldShowStickyCart =
          !entry.isIntersecting &&
          ((window.innerWidth >= 770) || 
          (window.innerWidth < 770 && currentScrollY > window.innerHeight));
  
        if (isScrollingDown && shouldShowStickyCart) {
          stickyCart.classList.remove('is-hidden');
        } else if (!isScrollingDown && entry.isIntersecting) {
          stickyCart.classList.add('is-hidden');
        }
      });
    };
  
    const observerOptions = { threshold: 0.8 };
    const observer = new IntersectionObserver(observerCallback, observerOptions);
  
    observer.observe(observerTarget);
});
  